$(document).ready(function () {
    var cardItemDescriptionSelector = ".card > .card-item > .card-item-description";
    var clampCardDescription = function () {
        $(cardItemDescriptionSelector).each(function (n, e) {
            $clamp(e, { clamp: 'auto' });
        });
    };

    // we have trouble running clamp with 'auto' clamping on IE => drop the ellipsis and just use overflow hidden
    var userAgent = window.navigator.userAgent;
    if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1 || userAgent.indexOf('Edge') > -1) {
        clampCardDescription = function () {
            $(".card > .card-item > .card-item-description").each(function (n, e) {
                $(e).css('overflow-y', 'hidden');
            });
        }
    }
   
    clampCardDescription();

    $(window).resize(function () {
        clampCardDescription();
    });
});



